import { defineStore } from "pinia";

export const useCustomerStore = defineStore('customer', {
    state: () => ({
        customer: {},
        customers: [],
        selectCustomers: [],
    }),
    actions: {
        setCustomer(customer) {
            this.customer = customer
        },
        setCustomers(customers) {
            this.customers = customers
        },
        setSelectCustomers(selectCustomers) {
            this.selectCustomers = selectCustomers
        },
        addCustomer(customer) {
            this.customers.unshift(customer)
        },
        updateCustomer(customer) {
            let index = this.customers.findIndex(cl => cl.id === customer.id)
            this.customers.splice(index, 1, customer)
        },
        deleteCustomer(customer) {
            let index = this.customers.findIndex(cl => cl.id === customer.id)
            this.customers.splice(index, 1)
        },
    },
});